module.exports = __webpack_public_path__ + "img/Gallop-TV.150180fd.svg";